const determinationCategories = Object.freeze({
  UnSet: 0,
  Exception: 1,
  Quotation: 2,
  RFP: 3,
});

export default determinationCategories;
